// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_UA-Yi","page":"page_v-lio","g-wrapper":"g-wrapper","g-highlight":"g-highlight","sw-video":"sw-video"};